export default __webpack_public_path__ + "static/media/roz3-small.bb210e3c.png";